'use es6';

import { getFirstName, getEmail } from './salesUsersGetters';
export const getUserSortKey = user => {
  return getFirstName(user) || getEmail(user);
};